export default __webpack_public_path__ + "static/ai-mark-46eff73ae2f64a0eb0cb5e76bfabc818.svg";